import { useId } from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function ListRow({
  as,
  leading,
  title,
  description,
  meta,
  trailing,
  selected = false,
  disabled = false,
  busy = false,
  className = "",
  onClick,
  ...props
}) {
  const generatedId = useId().replace(/:/g, "");
  const titleId = `lz-v2-list-row-title-${generatedId}`;
  const descriptionId = description
    ? `lz-v2-list-row-description-${generatedId}`
    : undefined;
  const Component = as || (onClick ? "button" : "div");
  const isNativeButton = Component === "button";
  const isDisabled = disabled || busy;

  return (
    <Component
      {...props}
      type={isNativeButton ? "button" : undefined}
      onClick={isDisabled ? undefined : onClick}
      disabled={isNativeButton ? isDisabled : undefined}
      aria-disabled={!isNativeButton && isDisabled ? "true" : undefined}
      aria-busy={busy || undefined}
      aria-pressed={isNativeButton && selected ? "true" : undefined}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      className={joinClassNames(
        "lz-v2-list-row",
        onClick && "lz-v2-list-row--interactive",
        selected && "lz-v2-list-row--selected",
        isDisabled && "lz-v2-list-row--disabled",
        className
      )}
    >
      {leading ? <span className="lz-v2-list-row__leading">{leading}</span> : null}
      <span className="lz-v2-list-row__copy">
        <span className="lz-v2-list-row__title" id={titleId}>{title}</span>
        {description ? (
          <span className="lz-v2-list-row__description" id={descriptionId}>
            {description}
          </span>
        ) : null}
        {meta ? <span className="lz-v2-list-row__meta">{meta}</span> : null}
      </span>
      {trailing ? <span className="lz-v2-list-row__trailing">{trailing}</span> : null}
    </Component>
  );
}
